import { useContext, useEffect, useState } from "react";
import AntdTable from "../../../antd/Table/Table";
import { filtrationcontext } from "../../../../context/Filtercontext";
import trans, { getLateLimitInMinutes, isRTL } from "../../../../utils";
import { exportContext } from "../../../../context/ExportDataContext";
import { Tag } from "antd";
import { useReportTableColumns } from "../../ReportColumns/reportColumns";

const AttendanceReportTable = ({
  startDate,
  endDate,
  currentPage,
  setCurrentPage,
  data,
  isLoading,
  selectedids,
  filters,
}) => {
  const { setFileName, setExportIds, setStartDateE, setEndDateE } =
    useContext(exportContext);
  const {
    setSort: SetSortFilter,
    limit,
    setLimit,
  } = useContext(filtrationcontext);
  const [sort, setSort] = useState({
    by: "",
    order: "",
  });

  useEffect(() => {
    return () => {
      SetSortFilter({ type: "", value: "" });
      localStorage.setItem("page", 1);
    };
  }, [SetSortFilter]);

  const columns = [
    {
      title: trans("Code"),
      dataIndex: "employeeId",
      width: 150,
      fixed: !isRTL ? "left" : undefined,
      render: (name) => (
        <span className={"table-element-name ps-0"}>{name}</span>
      ),
    },
    {
      title: trans("Name"),
      dataIndex: "technicianName",
      width: 150,
      sorter: true,
      fixed: !isRTL ? "left" : undefined,
    },
    {
      title: trans("Job Title"),
      dataIndex: "jobTitle",
      width: 150,
      sorter: true,
    },
    // {
    //   title: trans("department"),
    //   dataIndex: "department",
    //   width: 150,
    //   sorter: true,
    // },
    {
      title: trans("Supervisor"),
      dataIndex: "supervisor",
      width: 150,
    },
    {
      title: trans("Total Shifts"),
      dataIndex: "scheduledWorkingDays",
      width: 150,
      sorter: true,
      render: (_, record) => record?.summary?.scheduledWorkingDays || "0",
    },
    {
      title: trans("Shift Attendance"),
      dataIndex: "actualAttendedDays",
      width: 200,
      sorter: true,
      render: (_, record) => record?.summary?.actualAttendedDays || "0",
    },
    {
      title: trans("Absent Shifts"),
      dataIndex: "absentDays",
      width: 200,
      sorter: true,
      render: (_, record) => record?.summary?.absentDays || "0",
    },
    {
      title: trans("Late Attendance"),
      dataIndex: "lateDays",
      width: 200,
      sorter: true,
      render: (_, record) => record?.summary?.lateDays || "0",
    },
    {
      title: trans("Early Departure"),
      dataIndex: "earlyLeaveDays",
      width: 200,
      sorter: true,
      render: (_, record) => record?.summary?.earlyLeaveDays || "0",
    },
    {
      title: trans("Total Work Hours"),
      dataIndex: "totalWorkMinutes",
      width: 150,
      sorter: true,
      render: (_, record) => record?.summary?.totalWorkMinutesFormatted || "0",
    },
    {
      title: trans("Total Late"),
      dataIndex: "totalLateMinutes",
      width: 150,
      sorter: true,
      render: (_, record) => {
        const limit = getLateLimitInMinutes(
          filters.lateThreshold,
          filters.lateUnit
        );
        const totalLate = record?.summary?.totalLateMinutes || 0;
        const formatted = record?.summary?.totalLateMinutesFormatted || "0";
        const isExceeded = totalLate > limit;

        return (
          <span style={{ color: isExceeded ? "red" : "green" }}>
            {formatted}
          </span>
        );
      },
    },
    {
      title: trans("Total Early Departure"),
      dataIndex: "totalEarlyLeaveMinutes",
      width: 200,
      sorter: true,
      render: (_, record) =>
        record?.summary?.totalEarlyLeaveMinutesFormatted || "0",
    },
    {
      title: trans("Total Overtime"),
      dataIndex: "totalOvertimeMinutes",
      width: 200,
      sorter: true,
      render: (_, record) => (
        <Tag
          color={
            record?.summary?.totalOvertimeMinutes >= 1 ? "green" : "default"
          }
        >
          {record?.summary?.totalOvertimeMinutesFormatted || "0"}
        </Tag>
      ),
    },
    {
      title: trans("Shift Attendance %"),
      dataIndex: "attendanceRate",
      width: 200,
      sorter: true,
      render: (_, record) => {
        const limit = filters.attendanceThreshold || 100;
        const attendanceRate = record?.summary?.attendanceRate || 0;
        const formatted = record?.summary?.attendancePercent || "0";
        const isExceeded = limit > 0 && attendanceRate < limit;
        return (
          <span style={{ color: isExceeded ? "red" : "inherit" }}>
            {formatted}
          </span>
        );
      },
    },
    {
      title: trans("Shift Absence %"),
      dataIndex: "absenceRate",
      width: 200,
      sorter: true,
      render: (_, record) => `${record?.summary?.absenceRate} %` || "0",
    },
  ];
  const visibleColumns = useReportTableColumns(columns);

  useEffect(() => {
    if (data) {
      setStartDateE(startDate);
      setEndDateE(endDate);
    }
  }, [data, startDate, endDate, selectedids]);

  const handleTableChange = (pagination, filters, sorter) => {
    if (sorter.order) {
      SetSortFilter({
        by: sorter.field,
        order: sorter.order === "ascend" ? "asc" : "desc",
      });
    } else {
      SetSortFilter({
        by: "",
        order: "",
      });
    }
  };

  return (
    <div className="bg-white-rounded-top mt-3 table-parent">
      <AntdTable
        columns={visibleColumns}
        dataSource={data?.technicians || []}
        loading={isLoading}
        pageSize={limit}
        totalItems={data?.totalResults || 0}
        currentPage={currentPage}
        onPageChange={(page) => setCurrentPage(page)}
        onLimitChange={(newLimit) => {
          setLimit(newLimit);
          setCurrentPage(1);
        }}
        onTableChange={handleTableChange}
        scrollY={350}
      />
    </div>
  );
};

export default AttendanceReportTable;
